import {
    preOnboardingBusinessDetailsPath,
    preOnboardingBusinessPurposePath,
    preOnboardingBusinessSizePath,
    preOnboardingSelectIndustryPath,
} from '../../../../Routes';

export const GET_PREONBOARDING_STEP = 'GET_PREONBOARDING_STEP';
export const CLEAR_PREONBOARDING_STEP = 'CLEAR_PREONBOARDING_STEP';

export const PRE_ONBOARDING_PATH_ARR = [
    null,
    preOnboardingSelectIndustryPath,
    preOnboardingBusinessDetailsPath,
    preOnboardingBusinessPurposePath,
    preOnboardingBusinessSizePath,
];